import _ from 'lodash'
import moment from 'moment'
import { createAction, createReducer } from 'redux-act'
import constants from '../constants'

const selectContentId = createAction('CREATE/SELECT_CONTENT_ID')
const selectContentColor = createAction('CREATE/SELECT_CONTENT_COLOR')
const selectContentType = createAction('CREATE/SELECT_CONTENT_TYPE')
const selectNextContentId = createAction('CREATE/SELECT_NEXT_CONTENT_ID')
const selectPrevContentId = createAction('CREATE/SELECT_PREV_CONTENT_ID')
const setEventDate = createAction('CREATE/SET_EVENT_DATE')
const setNav = createAction('set nav')

const selectedContent = state =>
  state.create.selectingContentType ===
  constants.createNav.SELECT_CONTENT_TYPE_COLOR
    ? state.create.selectedContentColor
    : state.create.selectedContentId

const selectingContentType = state => state.create.selectedContentColor

const now = () => moment().valueOf()

const initialState = {
  selectingContentType: constants.createNav.SELECT_CONTENT_TYPE_COLOR,
  selectedContentColor: { r: 255, g: 255, b: 255, a: 1 },
  selectedContentId: 'solar',
  startDate: moment().valueOf(),
  endDate: moment().valueOf(),
  nav: constants.createNav.SCHEDULE_CONTENT,
}

const next = (arr, idx) => arr[(idx + 1) % arr.length]
const prev = (arr, idx) => (idx === 0 ? arr[arr.length - 1] : arr[idx - 1])

const listenTo = {
  [selectContentColor]: (state, selectedContentColor) => ({
    ...state,
    selectedContentColor,
  }),
  [selectContentType]: (state, selectingContentType) => ({
    ...state,
    selectingContentType,
  }),
  [selectContentId]: (state, selectedContentId) => ({
    ...state,
    selectedContentId,
  }),
  [selectNextContentId]: (state, contentIds) => ({
    ...state,
    selectedContentId: next(
      contentIds,
      _.indexOf(contentIds, state.selectedContentId),
    ),
  }),
  [selectPrevContentId]: (state, contentIds) => ({
    ...state,
    selectedContentId: prev(
      contentIds,
      _.indexOf(contentIds, state.selectedContentId),
    ),
  }),
  [setEventDate]: (state, { type, date }) => ({ ...state, [type]: date }),
  [setNav]: (state, nav) => ({
    ...state,
    nav,
  }),
}

export const selectors = {
  selectingContentType,
  selectedContent,
}

export const actions = {
  selectContentType,
  selectContentId,
  selectContentColor,
  selectNextContentId,
  selectPrevContentId,
  setEventDate,
  setNav,
}

export default createReducer(listenTo, initialState)



// WEBPACK FOOTER //
// ./src/reducers/create.js